'use client';

import { useDataLayerEventOnPageLoad } from '@coolblue-development/next-analytics/client';
import { PageType } from '@sharedTypes';

type Props = {
  vacancyTitle: string;
  pageType: PageType;
  vacancyId: string;
  postingId?: string;
  department: string;
};

export const VacancyAnalyticsConfig = ({
  vacancyTitle,
  pageType,
  vacancyId,
  postingId,
  department
}: Props) => {
  const event = [
    {
      vacancyTitle: vacancyTitle,
      pagetype: pageType,
      cbVacancyID: vacancyId,
      postingID: postingId,
      department: department
    }
  ];

  useDataLayerEventOnPageLoad(event);

  return <></>;
};
